import SwitchComponent from "./SwitchComponent";
import { useCallback } from "react";
import { useRobot } from "@portal/app/context/robotProvider";
import { NORNE_CENTERID } from "@portal/assets/banks";

interface Props {
  centerId: string;
}

/**
 * Component to toggle between two languages.
 * @returns a switch toggle button.
 */
export const LanguageSelector = ({ centerId }: Props) => {
  const { isDefaultLanguage, setIsDefaultLanguage } = useRobot();

  const OnLanguageClick = useCallback(() => {
    setIsDefaultLanguage(!isDefaultLanguage);
  }, [isDefaultLanguage, setIsDefaultLanguage]);

  return <SwitchComponent checked={!isDefaultLanguage} onChange={OnLanguageClick} invert={getInvertedBanks(centerId)} />;
};

const getInvertedBanks = (centerId: string) => {
  return [NORNE_CENTERID, "2220", "9820", "4589", "4730", "4605"].includes(centerId);
};
